import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';

import { useMatch } from 'react-router-dom';
import { useHomeData } from '../LoadHomeData/HomeDataProvider';
import { useTranslations } from '../Translations/TranslationsProvider';
import { HeaderDrawer } from './HeaderDrawer';
import { LogoButton } from './HeaderLogo';
import { HeaderScanButtons } from './HeaderScanButtons';

export const Header = () => {
    const { translations } = useTranslations();
    const { homepageData } = useHomeData();
    const match = useMatch('/evacuations/*');

    if (!translations) {
        return null;
    }

    return (
        <AppBar position="fixed">
            <Toolbar>
                <HeaderDrawer translations={translations} />
                <LogoButton />
                {homepageData?.siteAccessSituation && !match && <HeaderScanButtons />}
            </Toolbar>
        </AppBar>
    );
};
